import { Avatar, useMediaQuery } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface ProfileImageBlurProps {
  defaultAvatar: boolean | null;
  defaultAvatarPath?: string;
  uid: string | null;
  avatar: string | null;
  imgHeight: string;
  imgWidth: string;
  handle?: string | null;
}

const ProfileImageBlur: React.FC<ProfileImageBlurProps> = ({
  defaultAvatar,
  defaultAvatarPath,
  uid,
  avatar,
  imgHeight,
  imgWidth,
  handle
}) => {
  const isMobile = useMediaQuery('(max-width:600px)');
  const isHome = location.pathname === '/';
  const navigate = useNavigate();

  return (
    <div>
      <Avatar
        sx={{
          width: imgWidth,
          height: imgHeight,
          filter: defaultAvatar ? 'none' : imgWidth > '100px' ? 'blur(2px)' : 'blur(1px)'
        }}
        src={
          defaultAvatar
            ? defaultAvatarPath
              ? defaultAvatarPath
              : `${process.env.REACT_APP_DEFAULT_AVATAR}/APP/UserAvatars/${avatar}`
            : `${process.env.REACT_APP_DEFAULT_AVATAR}/${uid}/PROFILE/IMAGES/medium/${avatar}`
        }
        onClick={() => navigate(`/user/${handle}`)}
      />
    </div>
  );
};

export default ProfileImageBlur;
